<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card tile :loading="isLoading">
      <dialog-toolbar
        :document="document"
        @closeDialog="dialog = false"
      />
      <v-card-text class="mt-6">
        <form>
          <v-textarea
            v-model="comment"
            label="Комментарий"
            auto-grow
            solo
            flat
            outlined
            hide-details
          />
        </form>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          large
          fab
          color="success"
          @click="saveComment"
        >
          <v-icon large>mdi-content-save</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DocumentApi from 'app/document/api'
import dialogToolbar from './dialogToolbar'

export default {
  name: 'comment',
  components: {
    dialogToolbar
  },
  data () {
    return {
      dialog: false,
      document: {},
      isLoading: false,
      comment: ''
    }
  },
  methods: {
    async open (document) {
      this.comment = ''
      this.document = document
      this.dialog = true
      await this.loadData()
    },
    async loadData () {
      this.isLoading = true
      try {
        let response = await DocumentApi.getComment(this.document.name, this.document.doc_id)
        this.comment = response.comment
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        console.log(e)
      }
    },
    async saveComment () {
      this.isLoading = true
      await DocumentApi.saveComment(this.document.name, this.document.doc_id, this.comment)
      this.isLoading = false
      this.dialog = false
    }
  }
}
</script>

<style scoped>

</style>
